


































































import CustomFieldConfigurationForm from "@/components/report/CustomFieldConfigurationForm.vue";
import { IDialog } from "@/lib/interfaces/dialog.interface";
import { requiredRule } from "@/lib/rules/requiredRule";
import { simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { handleError } from "@/lib/utility/handleError";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import { ReportGroup, IReportGroup } from "@/models/report-group.entity";
import { MrfiktivReferenceGen } from "@/services/mrfiktiv/v1/data-contracts";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import ConfirmActionDialog from "../../utility/ConfirmActionDialog.vue";
import { ICustomFieldListElement } from "@/models/custom-field-list-element.entity";

@Component({
  components: {
    ConfirmActionDialog,
    CustomFieldConfigurationForm
  },
  filters: {
    simpleDoubleDigitDate
  }
})
export default class ReportGroupCreateDialog extends mixins(PermissionMixin) implements IDialog {
  readonly ReportGroup = ReportGroup;

  @Prop()
  partnerId!: string;

  @Prop()
  hideButton!: boolean;

  isDialogActive = false;

  isLoading = false;

  reportGroup: IReportGroup = new ReportGroup({});

  get customFieldConfig(): ICustomFieldListElement[] {
    return this.reportGroup.configuration.customFieldConfig.filter(
      f => !this.status.map(s => s.customField.id).includes(f.customField.id)
    );
  }

  set customFieldConfig(customFieldConfig: ICustomFieldListElement[]) {
    this.reportGroup.configuration.customFieldConfig = customFieldConfig;
  }

  get requiredRule() {
    return [requiredRule()];
  }

  get status(): ICustomFieldListElement[] {
    const status = this.reportGroup.configuration.status;

    const arrified: ICustomFieldListElement[] = [];
    if (status) {
      arrified.push(status);
    }

    return arrified;
  }

  set status(value: ICustomFieldListElement[]) {
    this.reportGroup.configuration.status = value?.[value.length - 1] || null;
  }

  open() {
    this.reportGroup = new ReportGroup({ partnerId: this.partnerId });
    this.isDialogActive = true;
    this.$nextTick(() => {
      (this.$refs.titleField as HTMLInputElement)?.focus();
    });
  }

  async onRightClick() {
    try {
      this.isLoading = true;
      await this.reportGroup.create();
      this.$emit("created", this.reportGroup);
      this.$toast.success("👍");
    } catch (e) {
      handleError(e);
    } finally {
      this.isLoading = false;
      this.close();
    }
  }

  onConfirm(item: MrfiktivReferenceGen) {
    this.$log.debug("onConfirm", item);
  }

  close(): void {
    this.isDialogActive = false;
  }
}
